import { createContext, useContext } from 'react'
import { AppConfigContext } from './AppConfigContext'

export const LocalizationContext = createContext({})

export const LocalizationContextProvider = ({ children }) => {
  // Read from AppConfigContext instead of making API call
  const appConfig = useContext(AppConfigContext)

  return (
    <LocalizationContext.Provider
      value={{
        localizedDataLoading: appConfig?.locale?.loading ?? false,
        localizedData: appConfig?.locale?.data ?? null,
        localizedDataError: appConfig?.locale?.error ?? null,
        refreshLocaleData: appConfig?.locale?.refreshFunction ?? (() => {}),
      }}
    >
      {children}
    </LocalizationContext.Provider>
  )
}
